import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import {
  setFormLoading,
  setFromDate,
  setToDate,
  setVMId,
  setVMOptionsToStore,
  setSubmitLoading
} from './actions';
import parseResponseToOptions from '../../utils/parseResponseToOptions';
import DownloadCSVComponent from './component';

class DownloadCSVContainer extends Component {
  constructor(){
    super();
    this.state={
      selectAll: false
    }
  }
  componentDidMount() {
    this.props.setFormLoading(true);
    this.props.getDataFromAPI(
      '/vendingmachines/all',
      'GET',
      undefined,
      response => {
        console.log(response);
        this.props.setVMOptionsToStore(response.list);
        this.props.setFormLoading(false);
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine details');
        this.props.setFormLoading(true);
      }
    );
  }

  handleFromDateChange = date => {
    this.props.setFromDate(moment(date));
  };

  handleToDateChange = date => {
    this.props.setToDate(moment(date));
  };

  onChangeOfVMID = (event, data) => {
    this.props.setVMId(data.value.join());
  };

  handleDownloadOrders = () => {
    this.props.setSubmitLoading(true);
    const dateFrom = this.props.downloadCSV && this.props.downloadCSV.from;
    const dateTo = this.props.downloadCSV && this.props.downloadCSV.to;
    let vmId = this.props.downloadCSV && this.props.downloadCSV.vmId;
    const selectAll = this.state.selectAll;

    if (!vmId && !selectAll) {
      this.props.setSubmitLoading(false);
      return toastr.warning('Warning', 'Select Vending Machine');
    }
    
    if(selectAll){
      vmId='';
    }

    const dateDiff = dateTo.diff(dateFrom, 'days');
    if (dateDiff > 90) {
      this.props.setSubmitLoading(false);
      return toastr.warning('Warning', 'Range caanot be more than 90 days');
    }

    this.props.getDataFromAPI(
      `/downloads/orders?dateTo=${dateTo.format('YYYY-MM-DD')}&dateFrom=${dateFrom.format(
        'YYYY-MM-DD'
      )}&vmId=${vmId}`,
      'GET',
      undefined,
      response => {
        toastr.success('Successful', 'CSV is downloading');
        this.props.setSubmitLoading(false);
        window.open(response.link, '_blank');
      },
      err => {
        this.props.setSubmitLoading(false);
        toastr.error('Error', 'Download Failed');
        console.error(err);
      }
    );
  };

  handleDownloadOLI = () => {
    this.props.setSubmitLoading(true);
    const dateFrom = this.props.downloadCSV && this.props.downloadCSV.from;
    const dateTo = this.props.downloadCSV && this.props.downloadCSV.to;
    let vmId = this.props.downloadCSV && this.props.downloadCSV.vmId;
    const selectAll= this.state.selectAll

    if (!vmId && !selectAll) {
      this.props.setSubmitLoading(false);
      return toastr.warning('Warning', 'Select Vending Machine');
    }

    if(selectAll){
      vmId='';
    }

    const dateDiff = dateTo.diff(dateFrom, 'days');
    if (dateDiff > 90) {
      this.props.setSubmitLoading(false);
      return toastr.warning('Warning', 'Range caanot be more than 90 days');
    }

    this.props.getDataFromAPI(
      `/downloads/oli?dateTo=${dateTo.format('YYYY-MM-DD')}&dateFrom=${dateFrom.format(
        'YYYY-MM-DD'
      )}&vmId=${vmId}`,
      'GET',
      undefined,
      response => {
        toastr.success('Successful', 'CSV is downloading');
        this.props.setSubmitLoading(false);
        window.open(response.link, '_blank');
      },
      err => {
        this.props.setSubmitLoading(false);
        toastr.error('Error', 'Download Failed');
        console.error(err);
      }
    );
  };

  handleDownloadPayments = () => {
    this.props.setSubmitLoading(true);
    const dateFrom = this.props.downloadCSV && this.props.downloadCSV.from;
    const dateTo = this.props.downloadCSV && this.props.downloadCSV.to;

    this.props.getDataFromAPI(
      `/downloads/payments?dateTo=${dateTo.format('YYYY-MM-DD')}&dateFrom=${dateFrom.format(
        'YYYY-MM-DD'
      )}`,
      'GET',
      undefined,
      response => {
        window.open(response.link, '_blank');
        toastr.success('Successful', 'CSV is downloading');
        this.props.setSubmitLoading(false);
      },
      err => {
        this.props.setSubmitLoading(false);
        toastr.error('Error', 'Download Failed');
        console.error(err);
      }
    );
  };

  handleDownloadManufacturerVariants = () => {
    this.props.setSubmitLoading(true);
    this.props.getDataFromAPI(
      '/downloads/mvs',
      'GET',
      undefined,
      response => {
        window.open(response.link, '_blank');
        toastr.success('Successful', 'CSV is downloading');
        this.props.setSubmitLoading(false);
      },
      err => {
        this.props.setSubmitLoading(false);
        toastr.error('Error', 'Download Failed');
        console.error(err);
      }
    );
  };

  selectAllVM = (e,data)=>{
    if (data.checked === true){
      this.setState(prev => ({
        selectAll: true
      }));
    }
    else{
      this.setState(prev => ({
        selectAll: false
      }));
    }
    
  }

  render() {
    const vmOptions = this.props.downloadCSV && this.props.downloadCSV.vmList;
    const dateFrom = this.props.downloadCSV && this.props.downloadCSV.from;
    const dateTo = this.props.downloadCSV && this.props.downloadCSV.to;
    const submitLoading = this.props.downloadCSV && this.props.downloadCSV.submitLoading;
    
    return (
      <DownloadCSVComponent
        dateFrom={dateFrom}
        dateTo={dateTo}
        changeFrom={this.handleFromDateChange}
        changeTo={this.handleToDateChange}
        changeVM={this.onChangeOfVMID}
        selectAllVM={this.selectAllVM}
        selectAll={this.state.selectAll}
        downloadOrders={this.handleDownloadOrders}
        downloadOLI={this.handleDownloadOLI}
        downloadPayments={this.handleDownloadPayments}
        downloadMV={this.handleDownloadManufacturerVariants}
        loading={submitLoading}
        vmOptions={parseResponseToOptions(vmOptions)}
      />
    );
  }
}

function mapStateToProps({ downloadCSV }) {
  return {
    downloadCSV
  };
}

export default withRouter(
  connect(mapStateToProps, {
    setFormLoading,
    setFromDate,
    setToDate,
    setVMId,
    setVMOptionsToStore,
    setSubmitLoading,
    getDataFromAPI
  })(DownloadCSVContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/DownloadCSV/container.jsx